export enum WidgetType {
  Paperless = 'paperless',
  TipsForm = 'tipsForm',
  Form1099Ready = 'form1099Ready',
  Form1099Soon = 'form1099Soon',
  Form1099When = 'form1099When',
  FormW2Ready = 'formW2Ready',
  FormW2Soon = 'formW2Soon',
  FormW2When = 'formW2When',
  TimeOff = 'timeOff',
  Facts = 'facts',
  None = 'none',
}

export enum ImagePosition {
  Hidden = 'hidden',
  Middle = 'middle',
  Bottom = 'bottom',
}
export enum TaxFormType {
  EmployeeW2 = 'W',
  Contractor1099 = 'M',
}

export enum Description {
  Paperless = 'Secure deposits to your bank. Get your money faster and save some trees!',
  Form1099Ready = 'Tax season is approaching. Grab your 1099-NEC and get ready for taxes and tax returns.',
  Form1099Soon = "January means a new year and 1099-NECs! We'll post your 1099-NEC on or before ",
  Form1099When = "We'll post your 1099-NEC on or before ",
  FormW2Ready = 'Tax season is approaching. Grab your W-2 and get ready for taxes and tax returns.',
  FormW2Soon = "January means a new year and W-2s! We'll post your W-2 on or before ",
  FormW2When = "We'll post your W-2 on or before ",
  TipsForm = 'Are you a tipped employee? Download your tip reporting forms:',
  TimeOff = '',
  Facts = '',
}

export enum WidgetFacts {
  Percentage = 'Approximately 99.9% of businesses in the U.S. are classified as small businesses, according to the U.S. Small Business Administration.',
  Employees = "In a 2021 U.S. SBA survey, there were 61.2 million employees employed by small businesses. That's 47% of all US employees!",
  Jobs = 'According to the U.S. SBA, small companies create 1.5 million jobs annually and account for 64% of new jobs created in the US.',
}

export enum WidgetIcon {
  Paperless = 'fa-leaf',
  Form1099Ready = 'fa-file-invoice-dollar',
  Form1099Soon = 'fa-file-invoice-dollar',
  Form1099When = 'fa-solid fa-question',
  FormW2Ready = 'fa-file-invoice-dollar',
  FormW2Soon = 'fa-file-invoice-dollar',
  FormW2When = 'fa-solid fa-question',
  TimeOff = 'fa-tree-palm',
  Facts = 'fa-solid fa-question',
}

export enum IconColor {
  Blue = '#3b99ea',
  Green = '#88ac2e',
}

export enum Image {
  Paperless = 'assets/widgets/paperless-widget.svg',
  TaxFormsNotice = 'assets/widgets/tax-forms-widget.svg',
  TimeOff = 'assets/widgets/time-off-widget.svg',
  Facts = 'assets/widgets/facts-widget.svg',
}

export enum LinkLabel {
  Paperless = 'Setup Direct Deposit',
  Form1099Ready = 'Go to Tax Forms',
  Form1099Soon = 'Go to Tax Forms',
  FormW2Ready = 'Go to Tax Forms',
  FormW2Soon = 'Go to Tax Forms',
  TipForm4070 = '4070 - Report tips to employer',
  TipForm4070A = '4070A - Daily record of tips',
}

export enum LinkRoute {
  Paperless = '/direct-deposit',
  Form1099Ready = '/tax-forms',
  Form1099Soon = '/tax-forms',
  FormW2Ready = '/tax-forms',
  FormW2Soon = '/tax-forms',
}

export enum TipsForm {
  F4070 = 'f4070',
  F4070a = 'f4070a',
}

export enum Title {
  Paperless = 'Go paperless',
  Form1099Ready = 'Your 1099-NEC is ready!',
  Form1099When = 'When will I get my 1099-NEC?',
  Form1099Soon = '1099-NEC available soon',
  FormW2Ready = 'Your W-2 is ready!',
  FormW2Soon = 'W-2 available soon',
  FormW2When = 'When will I get my W-2?',
  TipsForm = 'Tips Forms',
  TimeOff = 'Time Off Balance',
  Facts = 'Did you know?',
}
